export enum Environment {
  local = 'local',
  preprod = 'pp',
  prod = 'www',
}

export const getCurrentEnvironment = (): string | undefined => {
  return process.env.GH_ENV;
};

export const isProduction = (): boolean => {
  return getCurrentEnvironment() === Environment.prod;
};
